var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "details-view",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Tool.Setting"),
        width: "650px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                lazy: true,
                label: _vm.$t("SystemMaintenance.TabSettings"),
                name: "tabSettings"
              }
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "main-content",
                  staticStyle: { "margin-top": "20px", "margin-left": "20px" },
                  attrs: { "label-width": "120px", "label-position": "left" }
                },
                [
                  _vm.pageType === _vm.arPageType
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.StandardFeesTab")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                on: { change: _vm.onHideTabChargeChange },
                                model: {
                                  value: _vm.chargeArForm.hideTabCharge,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.chargeArForm,
                                      "hideTabCharge",
                                      $$v
                                    )
                                  },
                                  expression: "chargeArForm.hideTabCharge"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.HideStandardFeeTab"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("queryJob.FeeReceivable")) + ":"
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  disabled: !_vm.chargeArForm.hideTabCharge
                                },
                                model: {
                                  value: _vm.chargeArForm.arAloneShow,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.chargeArForm,
                                      "arAloneShow",
                                      $$v
                                    )
                                  },
                                  expression: "chargeArForm.arAloneShow"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.DisplayAsASeparateTab"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SalesInquiryApplication"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.chargeArForm.arShowInSalesInquiry,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.chargeArForm,
                                      "arShowInSalesInquiry",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "chargeArForm.arShowInSalesInquiry"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SalesTheCustomTabUI"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.pageType === _vm.apPageType
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("queryJob.CostsPayable")) + ":"
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  disabled: !_vm.chargeArForm.hideTabCharge
                                },
                                on: { change: _vm.onApAloneShowChange },
                                model: {
                                  value: _vm.chargeApForm.apAloneShow,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.chargeApForm,
                                      "apAloneShow",
                                      $$v
                                    )
                                  },
                                  expression: "chargeApForm.apAloneShow"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.DisplayAsASeparateTab"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SalesInquiryApplication"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  disabled: !_vm.chargeApForm.apAloneShow
                                },
                                model: {
                                  value: _vm.chargeApForm.apShowInSalesInquiry,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.chargeApForm,
                                      "apShowInSalesInquiry",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "chargeApForm.apShowInSalesInquiry"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SalesTheCustomTabUI"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.salesInquiryApplyPages.includes(_vm.pageType)
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SalesInquiryApplication"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value:
                                    _vm.salesInquiryForm.showInSalesInquiry,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.salesInquiryForm,
                                      "showInSalesInquiry",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "salesInquiryForm.showInSalesInquiry"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SalesTheCustomTabUI"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.internalBillApplyPages.includes(_vm.pageType)
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.HideDefaultButton"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.internalBillForm.newReceiveHide,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.internalBillForm,
                                      "newReceiveHide",
                                      $$v
                                    )
                                  },
                                  expression: "internalBillForm.newReceiveHide"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.AdditionalReceivables"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.internalBillForm.newPayHide,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.internalBillForm,
                                      "newPayHide",
                                      $$v
                                    )
                                  },
                                  expression: "internalBillForm.newPayHide"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.AdditionalPayable"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.internalBillForm.editHide,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.internalBillForm,
                                      "editHide",
                                      $$v
                                    )
                                  },
                                  expression: "internalBillForm.editHide"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("Message.Edit")))]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.overseaBillApplyPages.includes(_vm.pageType)
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.HideDefaultButton"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.overseaBillForm.newHide,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.overseaBillForm,
                                      "newHide",
                                      $$v
                                    )
                                  },
                                  expression: "overseaBillForm.newHide"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("queryJob.Add")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.overseaBillForm.editHide,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.overseaBillForm,
                                      "editHide",
                                      $$v
                                    )
                                  },
                                  expression: "overseaBillForm.editHide"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("Message.Edit")))]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }